
(() => {
  'use strict';
  if (window.WBMHomepageReady) return;
  window.WBMHomepageReady = true;
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  function filterProducts(type) {
    const grid = $('[data-wbm-products]');
    if (!grid) return;
    let count = 0;
    $$('[data-wbm-support]', grid).forEach(card => {
      const show = type === 'all' || card.dataset.wbmSupport === type;
      card.hidden = !show;
      if (show) count++;
    });
    $$('[data-wbm-filter]', grid).forEach(button => {
      const active = button.dataset.wbmFilter === type;
      button.classList.toggle('wbm-is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const status = $('[data-wbm-filter-status]', grid);
    if (status) status.textContent = status.dataset.wbmStatusText.replace('__COUNT__', String(count));
  }
  function populateFit(dialog) {
    const select = $('[data-wbm-model-select]', dialog);
    const option = select && select.selectedOptions[0];
    if (!option) return;
    let text = '';
    try { text = JSON.parse(option.dataset.wbmMeasurements || '""'); } catch (_) {}
    const list = $('[data-wbm-measurements-list]', dialog);
    if (list) list.replaceChildren(...text.split(/\r?\n/).filter(line => line.trim()).map(line => {
      const item = document.createElement('li');
      item.textContent = line;
      return item;
    }));
    const link = $('[data-wbm-fit-product]', dialog);
    if (link && option.dataset.wbmProductUrl) link.href = option.dataset.wbmProductUrl;
  }
  function show(dialog) {
    if (!dialog || dialog.open) return;
    if (dialog.matches('[data-wbm-fit-dialog]')) populateFit(dialog);
    dialog.showModal();
  }
  function init() {
    $$('[data-wbm-fit-dialog]').forEach(populateFit);
    filterProducts('all');
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const filter = target.closest('[data-wbm-filter]');
    if (filter) filterProducts(filter.dataset.wbmFilter);
    const choose = target.closest('[data-wbm-choose-support]');
    if (choose) {
      filterProducts(choose.dataset.wbmChooseSupport);
      const section = $('[data-wbm-products]');
      const heading = $('[data-wbm-products-heading]');
      if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
      if (section) section.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    if (target.closest('[data-wbm-open-fit]')) show($('[data-wbm-fit-dialog]'));
    if (target.closest('[data-wbm-open-menu]')) show($('[data-wbm-menu]'));
    const close = target.closest('[data-wbm-close-dialog]');
    if (close) close.closest('dialog').close();
    const menuLink = target.closest('[data-wbm-close-menu]');
    if (menuLink) { const menu = menuLink.closest('dialog'); if (menu) menu.close(); }
    if (target.matches('dialog[open]')) {
      const bounds = target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) target.close();
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-wbm-model-select]')) populateFit(event.target.closest('dialog'));
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {
    $$('dialog[open]').forEach(dialog => dialog.close());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
